import React from 'react';
import { Helmet } from 'react-helmet';
import gql from 'graphql-tag';
import ReactDOM from 'react-dom';
// import createHistory from 'history/createBrowserHistory';
import { LogOut } from '@emyw/auth-lib';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { Dimmer, Icon } from 'semantic-ui-react';
// import { Provider } from 'react-redux';
import {
    AuthClient, AccountClient, TSDBClient, TermsOfUse, PrivacyPolicy, GA, log,
} from '@emyw/core-lib';
// import { PrivateRoute } from '@emyw/auth-lib';
import 'semantic-ui-css/semantic.min.css';
// import { TermsModal, PrivacyModal } from './LegalModals';
// import paypal from 'paypal-rest-sdk';
// import registerServiceWorker from './registerServiceWorker';
import './index.css';

/* Login and authentication components */
import NotFound from './NotFound';

// import SignUpIntro from './pages/SignUpIntro';
import SelectPlan from './pages/SelectPlan';
import SetupAccount from './pages/SetupAccount';
import NewAccount from './pages/NewAccount';
import VerifyAccount from './pages/VerifyAccount';
import SelectPaymentMethod from './pages/SelectPaymentMethod';
import CardInfo from './pages/CardInfo';
import PayPal from './pages/PayPal';
import ConfirmSignUp from './pages/ConfirmSignUp';
// import SignUpComplete from './pages/SignUpComplete';
// import Profiles from './pages/Profiles';

import AppContext from './AppContext';

import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';

import { loadUser } from './actions/userActions';
import VerifiedAccount from './pages/VerifiedAccount';
import { getCurrentPromoCode, getUrlParams } from './utils';

// redux store configuration
// import configureStore from './store/configureStore';
// import StateLoader from './store/stateLoader';

// // configure the redux store
// const stateLoader = new StateLoader();
// const store = configureStore();
// store.subscribe(() => {
//     stateLoader.saveState(store.getState());
// });

// // If there is an authenticated user, then load the user into the store
// store.dispatch(loadUser());

const { REACT_APP_FREE_PLAN_CODE: FREE, REACT_APP_PREMIUM_PLAN_CODE: PREMIUM } = process.env;

class App extends React.Component {
    constructor(props) {
        super(props);
        /* eslint-disable react/no-unused-state */
        this.state = {
            user: null,
            planSettings: null,
            isMounted: false,
            termsModalOpen: false,
            policyModalOpen: false,
            currentStep: 'plan',
            ReactGA: GA.ReactGA,
            disableSocialLogin: true,
            // location: { // copy individual items rather than reference to actual location object
            //     pathname: window.location.pathname,
            //     hostname: window.location.hostname,
            //     origin: window.location.origin,
            //     reload: window.location.reload,
            // },
        };

        this.setAppState = this.setAppState.bind(this);
    }

    /* eslint-disable-next-line react/sort-comp */
    terminateBuffer = () => {
        const ele = document.getElementById('ipl-progress-indicator');
        if (ele) {
            /* Fade out */
            ele.classList.add('available');
            setTimeout(() => {
                /* Remove from DOM */
                ele.outerHTML = '';
            }, 2000);
        }
    }

    componentDidMount() {
        /* Load user into state */
        // log.trace('loadUser():', loadUser());
        /* (loadUser())().then(result => (
            // this.setState({ user }) // eslint-disable-line react/no-unused-state
            log.trace('result:', result)
        )); */
        this.recordEnjoyAnalytic();
        Promise.all([this.loadUser(), this.getPlanSettings()]).then(([user, planSettings]) => {
            const { disableSocialLogin } = this.state;
            /* If no stored progress and no authenticated user, set locally stored progress to 'plan' */
            if (!localStorage.getItem('enjoy-signup-progress') && (!user || user.signupCompletedOn)) {
                localStorage.setItem('enjoy-signup-progress', 'plan');
            }
            // planSettings = {}; // eslint-disable-line no-param-reassign
            const { freeSignupDisabled, planCodes } = planSettings;
            // Skip plan select if only one plan is available
            const nonFreePlans = (planCodes || []).filter(c => c !== FREE);
            const skipPlanSelect = freeSignupDisabled && nonFreePlans.length === 1;
            if (skipPlanSelect) {
                // Need to set plan code and signup progress in local storage so that page will not get routed back to plan
                localStorage.setItem('plan-code', nonFreePlans[0] || PREMIUM);
                if (localStorage.getItem('enjoy-signup-progress') === 'plan') {
                    localStorage.setItem('enjoy-signup-progress', disableSocialLogin ? 'newaccount' : 'setupaccount');
                }
            }
            this.setState({ user, planSettings, skipPlanSelect, isMounted: true });
            this.terminateBuffer();
        });
    }

    onCloseModals = () => this.setState({ termsModalOpen: false, policyModalOpen: false });

    loadUser = () => new Promise((resolve) => {
        loadUser('network-only')(({ user }) => {
            resolve(user);
        });
    });

    getPlanSettings = async () => {
        try {
            const res = await TSDBClient.query({
                query: gql`query {
                    getSystemSettings(codes: ["ACCOUNT_PLANS"]) {
                        code
                        data
                    }
                }`,
            });
            const planSettings = (res.data.getSystemSettings.find(settings => settings.code === 'ACCOUNT_PLANS') || {}).data || {};
            return planSettings;
        } catch (error) {
            log.error('Error getting plan settings', error);
            return {};
        }
    };

    recordEnjoyAnalytic = () => {
        const { search } = window.location;
        let urlParams = new URLSearchParams(search);
        if (urlParams.has('redirectTo') && search.indexOf('%3F')) {
            urlParams = new URLSearchParams(unescape(`?${search.slice(search.indexOf('%3F') + 3)}`));
        }
        if (urlParams.has('emhl')) {
            // enjoy message history link analytics
            log.trace('record enjoy analytic', window.location.href);
            const base64Id = urlParams.get('emhl');
            // parse out the id for the MailingHistory
            // log.trace(base64Id, req.originalUrl.split('web-beacon-'), unescape(base64Id));
            log.trace(Buffer.from(unescape(base64Id), 'base64').toString('ascii'));
            const mailingHistoryId = parseInt(Buffer.from(unescape(base64Id), 'base64').toString('ascii'), 10);
            // log.trace(mailingHistoryId);
            if (mailingHistoryId) {
                try {
                    const note = window.location.href;
                    AccountClient.mutate({
                        mutation: gql`mutation { logMailingHistory(mailingHistoryId: ${mailingHistoryId}, note: "${note}") { ok } }`,
                    });
                } catch (error) {
                    log.error(error);
                }
                log.trace('mutate mailingHistorylog');
            } else {
                log.trace('invalid emhl analytic');
            }
            // if (!urlParams.has('redirectTo')) window.history.replaceState(null, null, window.location.pathname);
        }
    }

    /* Set the AppContext state */
    setAppState(newState) {
        this.setState(newState);
    }

    checkIfWasRedirected = () => {
        /* Check for redirect in search string only if pathname starts with /signup (otherwise let main enjoy page handle redirect) */
        log.trace('window.location.pathname.match', window.location.pathname.match('/signup'));

        if (!window.location.pathname.match('/signup')) return null;

        const { disableSocialLogin } = this.state;
        const { params: urlParams, redirectTo } = getUrlParams();

        const tvSignUp = urlParams.get('tv');
        const alreadyInitialized = localStorage.getItem('tv-signup-initialized-using') === tvSignUp;
        if (tvSignUp && !alreadyInitialized) {
            log.trace(tvSignUp);
            try {
                const tvObject = JSON.parse(Buffer.from(unescape(tvSignUp), 'base64').toString('ascii'));
                log.trace(tvObject);

                // force a sign out if a previous user is signed in
                LogOut();
                const md = localStorage.getItem('activationCodeMetaData');
                localStorage.clear();
                localStorage.setItem('activationCodeMetaData', md);
                localStorage.setItem('enjoy-signup-progress', 'newaccount');
                localStorage.setItem('plan-code', tvObject.planCode);
                sessionStorage.setItem('user-form-values', JSON.stringify(tvObject));
                localStorage.setItem('tv-signup-initialized-using', tvSignUp);
                // We need to reload the page now that we have altered these storage items
                window.location.reload(false);
                // localStorage.setItem('tv', tvSignUp);
            } catch (error) {
                log.error(error);
            }
        }

        const planCode = urlParams.get('plancode');
        if (planCode) {
            log.trace(planCode);
            // check if this promo code is valid
            // since we are not activating, we can send in a fake userId at this time.
            if (['FREE', 'STANDARD', 'PREMIUM'].includes(planCode)) {
                const progress = (window.location.pathname.match('/signup/newaccount') || disableSocialLogin) ? 'newaccount' : 'setupaccount';
                localStorage.setItem('enjoy-signup-progress', progress);
                localStorage.setItem('plan-code', planCode);
            }
        }

        getCurrentPromoCode();

        // log.trace(myParam, `${window.location.origin}${myParam}`);
        return redirectTo;
    }

    // checkIfShouldRedirect = () => {
    //     // reload the page if we are not in the signup base path
    //     if (!window.location.pathname.match('^/signup*')
    //         && (localStorage.getItem('redirectingTo') || '') !== 'enjoy-website'
    //         && !localStorage.getItem('enjoy-website-loaded')) {
    //         localStorage.setItem('redirectingTo', 'enjoy-website');
    //         window.location.reload(true); // force server request
    //         return true;
    //     }
    //     localStorage.removeItem('redirectingTo');
    //     return false;
    // }

    render() {
        const { isMounted, skipPlanSelect, disableSocialLogin, termsModalOpen, policyModalOpen } = this.state;
        // log.trace('state user:', this.state.user);
        const redirectTo = this.checkIfWasRedirected();
        // if (this.checkIfShouldRedirect()) return null;
        let defaultStep = 'plan';
        if (skipPlanSelect) defaultStep = disableSocialLogin ? 'newaccount' : 'setupaccount';
        const defaultRoute = redirectTo || `/signup/${defaultStep}`;

        return (
            <ApolloProvider client={AuthClient}>
                {/* <Provider store={store}> */}
                <AppContext.Provider value={{ state: this.state, setAppState: this.setAppState }}>
                    <BrowserRouter>
                        {isMounted ? (// Only render after componentDidMount to ensure user is loaded correctly
                            <div className="container">
                                <div className="body-content">
                                    <SiteHeader />
                                    <div style={{ padding: '25px 25px 25px 25px' }}>
                                        {redirectTo && <Redirect to={redirectTo} />}
                                        {GA.init() && <GA.RouteTracker />}
                                        <Switch>
                                            {window.location.host === 'localhost:3012' && (
                                                // <Route path="/" exact component={() => <Redirect to="/signup" />} />
                                                <Route
                                                    path="/"
                                                    exact
                                                    component={() => <Redirect to={defaultRoute} />}
                                                />
                                            )}
                                            {/* <Route path="/signup" exact component={SignUpIntro} /> */}
                                            <Route
                                                path="/signup"
                                                exact
                                                component={() => <Redirect to={defaultRoute} />}
                                            />
                                            <Route path="/signup/plan" exact component={SelectPlan} />
                                            <Route path="/signup/setupaccount" exact component={SetupAccount} />
                                            <Route path="/signup/newaccount" exact component={NewAccount} />
                                            <Route path="/signup/verifyaccount" exact component={VerifyAccount} />
                                            <Route path="/signup/verifiedaccount" exact component={VerifiedAccount} />
                                            {/** NOTE:
                                             * No need to make following routes private, as a verification check is built in; If for some reason the
                                             * verification failed to redirect when no user is loaded, the following pages will return blank anyway.
                                             * */}
                                            <Route path="/signup/payment" exact component={SelectPaymentMethod} />
                                            <Route path="/signup/cardinfo" exact component={CardInfo} />
                                            <Route path="/signup/paypal" exact component={PayPal} />
                                            <Route path="/signup/confirm" exact component={ConfirmSignUp} />
                                            {/* <Route path="/signupcomplete" exact component={SignUpComplete} /> */}
                                            {/* <Route path="/profiles" exact component={Profiles} /> */}
                                            <Route path="/signup/*" component={NotFound} />
                                            {/* {window.location.host === 'localhost:3012' &&
                                                <Route path="/*" component={NotFound} />
                                            } */}
                                            <Route
                                                path="/"
                                                component={() => {
                                                    if (localStorage.getItem('redirectingTo') !== 'enjoy-website') {
                                                        localStorage.setItem('redirectingTo', 'enjoy-website');
                                                        window.location.reload(true); // force server request
                                                        return null;
                                                    }
                                                    localStorage.removeItem('redirectingTo');
                                                    // attempting to ensure that the page is reloaded
                                                    if (process.env.NODE_ENV === 'production') window.location.reload(true);
                                                    return <div>Directing to main site...</div>;
                                                }}
                                            />
                                        </Switch>
                                    </div>
                                </div>
                                <SiteFooter />
                                {/* <Modal open={termsModalOpen} onClose={this.onCloseModals} closeIcon>
                                    <Modal.Content scrolling><TermsOfUse /></Modal.Content>
                                </Modal>
                                <Modal open={policyModalOpen} onClose={this.onCloseModals} closeIcon>
                                    <Modal.Content><PrivacyPolicy /></Modal.Content>
                                </Modal> */}
                                <Dimmer
                                    active={termsModalOpen}
                                    onClickOutside={this.onCloseModals}
                                    page
                                    className="fullScreenContent"
                                >
                                    <Icon name="close" onClick={this.onCloseModals} />
                                    <TermsOfUse />
                                </Dimmer>
                                <Dimmer
                                    active={policyModalOpen}
                                    onClickOutside={this.onCloseModals}
                                    page
                                    className="fullScreenContent"
                                >
                                    <Icon name="close" onClick={this.onCloseModals} />
                                    <PrivacyPolicy />
                                </Dimmer>
                            </div>
                        ) : (
                            <Helmet>
                                <title>Enjoy Movies Your Way - Signup</title>
                                <meta name="description" content="Signup" />
                            </Helmet>
                        )}
                    </BrowserRouter>
                </AppContext.Provider>
            </ApolloProvider>
        );
    }
}

// ReactDOM.render(App, document.getElementById('root'));
ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
